import { formErrorAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/system';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle(() => ({
    text: {
        color: 'slt-red-error',
        textStyle: 'body-small',
        marginTop: 1,
    },
}));

export const FormError = defineMultiStyleConfig({
    baseStyle,
});
